import { useContext, useEffect } from "react";
import PoolRankingGrid from "../components/PoolRankingGrid/PoolRankingGrid";
import i18n from "../../../i18n";
import { RootContext } from "../../../providers/RootProvider";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import { useAptabase } from "@aptabase/react";

const RankingPage = () => {
  const { ranking, selectedPool } = useContext(RootContext);
  const { trackEvent } = useAptabase();

  useEffect(() => {
    trackEvent("page_view", { screenName: "ranking_page" });
  }, [trackEvent]);

  return (
    <PageContainer title={i18n.t("navigation:ranking:title")}>
      <PoolRankingGrid selectedPool={selectedPool} pools={ranking} />
    </PageContainer>
  );
};

export default RankingPage;
